import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/categories/create',
    name: 'categoryCreate',
    component: () => import('@/views/restricted/manufacturers/category/CategoryCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_CREATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/categories/:categoryId/edit',
    name: 'categoryUpdate',
    component: () => import('@/views/restricted/manufacturers/category/CategoryUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_UPDATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/categories/:categoryId',
    name: 'categoryDetail',
    component: () =>
      import('@/views/restricted/manufacturers/category/CategoryDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_READ_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  }
]
